import React, {useState, useEffect} from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import {formatCurrency, getModelPrices1, insuranceRatePrice, gpsRatePrice, calcTotalTour, getTourSuplements, calcTotalRemaining} from "../util"
import { 
    HeaderTypo,
    TableContainer, 
    StyledTableCell,
    StyledRowCell,
    Divider,
    StyledLink
} from './styles/resumenPayment/styles';
import moment from 'moment';


export const CustomizedTables = (
    data,
    prices
) => {
    const [model1Price, setModel1Price] = useState(0)
    const [insurancePrice, setInsurancePrice] = useState(0)
    const [gpsPrice, setGpsPrice] = useState(0)
    const [totalTourPrice, setTotalTourPrice] = useState(0)
    const [totalTourSuplements, setTotalTourSuplements] = useState(0)
    // ✅ NUEVO: Estado para datos del API
    const [apiBreakdown, setApiBreakdown] = useState(null)

    const tourPrices = data.prices
    const tour = data.data.booking.tour
    const booking = data.data.booking
    const totalRemaining = calcTotalRemaining(data.data, totalTourPrice.totalCost)
    
    // ✅ NUEVO: Detectar si hay datos del API disponibles
    const hasApiData = data.data && data.data.calculated_price_dynamic && data.data.calculated_price_dynamic.breakdown

    let cancelInsurancePrice = 0
    if(data.data.cancel_insurance[0]){
        cancelInsurancePrice = data.data.cancel_insurance[0].RentalItem.price
    }

    const hasPassenger = data.data.booking.p_first_name != null && String(data.data.booking.p_first_name).trim() !== ''
    const roommateName = String(booking.roommate || '').trim()
    const hasRoommate = !hasPassenger && roommateName.length > 0
    const isSingleRoom = Boolean(
        (data.data.single && data.data.single.length > 0) ||
        data.data.booking.r_single
    )
    const passengerDisplayName = hasPassenger
        ? `${String(booking.p_first_name || '').trim()} ${String(booking.p_last_name || '').trim()}`.trim()
        : ''
    const companionTotal = isSingleRoom
        ? (hasApiData && apiBreakdown
            ? formatCurrency(apiBreakdown.single || 0)
            : formatCurrency(tourPrices.singlePrice))
        : hasPassenger
            ? (hasApiData && apiBreakdown
                ? formatCurrency(apiBreakdown.passenger || 0)
                : formatCurrency(tourPrices.passengerPrice))
            : formatCurrency(0)

    const renderTourDates = (tour) => {
        const startDate = moment.utc(tour.tour_start_date);
        const endDate = moment.utc(tour.tour_end_date);
        const startDatePart = startDate.format("MMM D");
        const endDatePart = startDate.isSame(endDate, "month")
            ? endDate.format("D, YYYY")
            : endDate.format("MMM D, YYYY");
        
        return `${startDatePart} - ${endDatePart}`;
    };

    
    useEffect(()=>{
        const fetchFirstModelPrice = async () => {
            // ✅ NUEVO: Usar calculated_price_dynamic que viene directamente del endpoint /tour_clients/:id
            let breakdownFromApi = null
            if (data.data && data.data.calculated_price_dynamic && data.data.calculated_price_dynamic.breakdown) {
                breakdownFromApi = data.data.calculated_price_dynamic.breakdown
                setApiBreakdown(breakdownFromApi)
            }
            
            // Si hay datos del API, usarlos; si no, calcular en frontend
            if (breakdownFromApi) {
                // Usar datos del API centralizados
                setInsurancePrice({ vipTotalPrice: breakdownFromApi.vipInsurance || 0 })
                setGpsPrice({ gpsTotalPrice: breakdownFromApi.gps || 0 })
                setModel1Price(breakdownFromApi.vehicle || 0)
                setTotalTourPrice({ 
                    totalCost: breakdownFromApi.total || 0,
                    cancelInsuranceValue: breakdownFromApi.cancellationInsurance || 0
                })
                
                // Los suplementos se calculan localmente ya que pueden cambiar
                const totalSuplements = getTourSuplements(data.data)
                setTotalTourSuplements(totalSuplements.payedSuplement + totalSuplements.pendingSuplement)
            } else {
                // Cálculo original en frontend (fallback)
                const insuranceDailyPrice = await insuranceRatePrice(data.data)
                const gpsDailyPrice = await gpsRatePrice(data.data)
                const priceFirstChoice = await getModelPrices1(
                    data.data,
                    data.prices.models.data,
                    data.prices.prices.data,
                    data.data.vehicle_model_id
                );
                const totalTour = await calcTotalTour(data.data, tourPrices, priceFirstChoice, true)
                const totalSuplements = getTourSuplements(data.data)
                setTotalTourPrice(totalTour)
                setInsurancePrice(insuranceDailyPrice)
                setGpsPrice(gpsDailyPrice)
                setModel1Price(priceFirstChoice);
                setTotalTourSuplements(totalSuplements.payedSuplement + totalSuplements.pendingSuplement)
            }
        }
        fetchFirstModelPrice()
    }, [])


    return (
        <TableContainer component={Paper}>
            <HeaderTypo>Summary</HeaderTypo>
            <Table aria-label="customized table">
                <TableBody>
                    <StyledRowCell className='separate'>               
                        <StyledTableCell>Chosen tour</StyledTableCell>
                    </StyledRowCell>

                    <StyledRowCell>
                        <StyledTableCell className="light">Date</StyledTableCell>
                        <StyledTableCell align="right" className='grow'>{renderTourDates(tour)}</StyledTableCell>
                    </StyledRowCell>

                    <StyledRowCell>
                        <StyledTableCell className="light">Tour</StyledTableCell>
                        <StyledTableCell  className='grow' align="right">
                            <StyledLink href={`/#/tours/${tour.id}`} target='blank'>{tour.tour_name.tour_name_en}</StyledLink>
                        </StyledTableCell>
                    </StyledRowCell>

                    <StyledRowCell className='separate'>
                        <StyledTableCell className="light">Rider price</StyledTableCell>
                        <StyledTableCell className='grow' align="right">
                            {hasApiData && apiBreakdown ? `${formatCurrency(apiBreakdown.tour || 0)}` : `${formatCurrency(tourPrices.tourTotal)}`}
                        </StyledTableCell>
                    </StyledRowCell>

                    <StyledRowCell>
                        <StyledTableCell>
                            {isSingleRoom ? "Single room" : "Double room"}
                        </StyledTableCell>
                        <StyledTableCell className="light grow" align="right">Yes</StyledTableCell>
                    </StyledRowCell>

                    {hasPassenger && (
                    <StyledRowCell>
                        <StyledTableCell>Passenger</StyledTableCell>
                        <StyledTableCell className="light grow" align="right">
                            {passengerDisplayName || "Yes"}
                        </StyledTableCell>
                    </StyledRowCell>
                    )}

                    {hasRoommate && (
                    <StyledRowCell>
                        <StyledTableCell>Roommate</StyledTableCell>
                        <StyledTableCell className="light grow" align="right">
                            {roommateName}
                        </StyledTableCell>
                    </StyledRowCell>
                    )}

                    <StyledRowCell>
                        <StyledTableCell className="light">Total</StyledTableCell>
                        <StyledTableCell align="right" className='grow'>
                            {companionTotal}
                        </StyledTableCell>
                    </StyledRowCell>

                    <StyledRowCell className='separate'>
                        <StyledTableCell colSpan={2}><Divider /></StyledTableCell>
                    </StyledRowCell>

                    <StyledRowCell>
                        <StyledTableCell>Motorcycle - 1st Choice</StyledTableCell>
                        <StyledTableCell className="light grow" align="right">
                            {(data.data.vehicle.length !== 0 && data.data.rental_status === 3) && "Deleted (if tour canceled)"}
                            {data.data.vehicle.length === 0 
                            ? "Own motorcycle" 
                            : `${data.data.vehicle[0].model.model_name} (${data.data.vehicle[0].licence_plate} ${data.data.vehicle[0].renting ? "®" : ""})`}

                        </StyledTableCell>
                    </StyledRowCell>

                    <StyledRowCell>
                        <StyledTableCell className="light">Total</StyledTableCell>
                        <StyledTableCell className='grow' align="right">
                            {`${formatCurrency(model1Price)}`}
                        </StyledTableCell>
                    </StyledRowCell>

                    <StyledRowCell className='separate'>
                        <StyledTableCell colSpan={2}><Divider /></StyledTableCell>
                    </StyledRowCell>
                    
                    <StyledRowCell>
                        <StyledTableCell>Cancellation insurance</StyledTableCell>
                        <StyledTableCell className="light grow" align="right">
                        {data.data.cancel_insurance[0] ? "Yes" : "No"}
                        </StyledTableCell>
                    </StyledRowCell>
                    <StyledRowCell>
                        <StyledTableCell className="light">Total</StyledTableCell>
                        <StyledTableCell className='grow' align="right">{`${formatCurrency(totalTourPrice.cancelInsuranceValue)}`}</StyledTableCell>
                    </StyledRowCell>
                    <StyledRowCell className='divider'></StyledRowCell>

                    <StyledRowCell>
                        <StyledTableCell>Vip insurance</StyledTableCell>
                        <StyledTableCell className="light grow" align="right">{data.data.insurance[0] ? "Yes": "No"}</StyledTableCell>
                    </StyledRowCell>
                    <StyledRowCell>
                        <StyledTableCell className="light">Total</StyledTableCell>
                        <StyledTableCell className='grow'  align="right">{`${formatCurrency(insurancePrice.vipTotalPrice)}`}</StyledTableCell>
                    </StyledRowCell>
                    <StyledRowCell className='divider'></StyledRowCell>

                    <StyledRowCell>
                        <StyledTableCell>GPS</StyledTableCell>
                        <StyledTableCell className="light grow" align="right">
                        {(data.data.vehicle.length !== 0 && data.data.rental_status === 3) && "Gps device deleted"}
                        {data.data.device[0] ? "Yes" : "No"}
                        </StyledTableCell>
                    </StyledRowCell>
                    <StyledRowCell>
                        <StyledTableCell className="light">Total</StyledTableCell>
                        <StyledTableCell className='grow'  align="right">{`${formatCurrency(gpsPrice.gpsTotalPrice)}`}</StyledTableCell>
                    </StyledRowCell>
                    <StyledRowCell className='divider'></StyledRowCell>

                    <StyledRowCell>
                        <StyledTableCell>Suplements</StyledTableCell>
                        <StyledTableCell className="light grow" align="right">
                        {totalTourSuplements > 0 ? "Yes" : "No"}
                        </StyledTableCell>
                    </StyledRowCell>
                    <StyledRowCell>
                        <StyledTableCell className="light">Total</StyledTableCell>
                        <StyledTableCell className='grow' align="right">{`${formatCurrency(totalTourSuplements)}`}</StyledTableCell>
                    </StyledRowCell>
                    <StyledRowCell className='divider'></StyledRowCell>

                    <StyledRowCell>
                        <StyledTableCell>Rewards</StyledTableCell>
                        <StyledTableCell className="light grow" align="right">
                        {data.data.booking.reward_used ? "Yes" : "No"}
                        </StyledTableCell>
                    </StyledRowCell>
                    <StyledRowCell>
                        <StyledTableCell className="light">Total</StyledTableCell>
                        <StyledTableCell className='grow' align="right">
                            {hasApiData && apiBreakdown ? `${formatCurrency(apiBreakdown.rewards || 0)}` : `${formatCurrency(data.data.booking.rewards)}`}
                        </StyledTableCell>
                    </StyledRowCell>
                    <StyledRowCell className='divider'></StyledRowCell>

                    <StyledRowCell>
                        <StyledTableCell>Discount</StyledTableCell>
                        <StyledTableCell className="light grow" align="right">
                        {data.data.discount > 0 ? "Yes" : "No"}
                        </StyledTableCell>
                    </StyledRowCell>
                    <StyledRowCell>
                        <StyledTableCell className="light">Total</StyledTableCell>
                        <StyledTableCell className='grow' align="right">
                            {hasApiData && apiBreakdown ? `${formatCurrency(apiBreakdown.discount || 0)}` : `${formatCurrency(data.data.discount)}`}
                        </StyledTableCell>
                    </StyledRowCell>
                    <StyledRowCell className='divider'></StyledRowCell>

                    <StyledRowCell className='separate'>
                        <StyledTableCell colSpan={2}><Divider /></StyledTableCell>
                    </StyledRowCell>

                    <StyledRowCell>
                        <StyledTableCell className="big">Total cost</StyledTableCell>
                        <StyledTableCell className="big grow" align="right">
                            {hasApiData && apiBreakdown ? `${formatCurrency(apiBreakdown.total || 0)}` : `${formatCurrency(totalTourPrice.totalCost)}`}
                        </StyledTableCell>
                    </StyledRowCell>
{/* 
                    <StyledRowCell>
                        <StyledTableCell className="big">Remaining</StyledTableCell>
                        <StyledTableCell className="big grow" align="right">{`${formatCurrency(totalRemaining)}`}</StyledTableCell>
                    </StyledRowCell> */}

                    <StyledRowCell className='divider'></StyledRowCell>
                </TableBody>
            </Table>
        </TableContainer>
    );
}


// WEBPACK FOOTER //
// ./src/components/resumenPayments.js